import Common from "~/js/common/common";
import store from "~/js/store/store";
import Header from "~/js/common/header";
import Footer from "~/js/common/footer";
import Detail from "./detail";
import Tooltip from "~/js/common/tooltip";

export default class PurchaseHistory {
  constructor() {
    store.subscribe((mutation, state) => {
      if (mutation.type === "beforeScroll") {
      } else if (mutation.type === "init") {
        this.init();
      }
    });

    this.header = new Header();
    this.footer = new Footer();
    this.tooltip = new Tooltip();

    this.detail = [];
    const _order = document.querySelectorAll("._order");
    for (var i = 0; i < _order.length; i++) {
      this.detail.push(new Detail(_order[i]));
    }

    store.dispatch("init");
  }

  init() {
    window.scrollTo(0, 0);
    Common.init();
    Common.setupScrollY();
  }
}

document.addEventListener("DOMContentLoaded", () => {
  new PurchaseHistory();
});
